<section class="smart-pdf-uploader" [class.drag-active]="dragActive" [class.uploading]="uploading"
  (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
  <div class="smart-pdf-uploader-copy">
    <strong class="upload-title" role="button" tabindex="0" (click)="triggerBrowse()" (keydown.enter)="triggerBrowse()"
    (keydown.space)="triggerBrowse()">Upload Smart PDF Schematic</strong>
    <small>Drag and drop a .pdf file here or browse. Max size: {{ formatBytes(maxFileSizeBytes) }}.</small>
    @if (selectedFileName) {
      <small>Selected: {{ selectedFileName }}</small>
    }
  </div>
  <input #smartPdfInput type="file" accept=".pdf,application/pdf" hidden (change)="onFileSelected($event)" />
</section>